export const agenda = {
  agendaDuration: 'trukmė',
  agendaCurtainCopy: 'Kopijuoti nuorodą',
  agendaCurtainFlag: 'Pažymėti turinį',
  agendaCurtainFlagSent: 'Turinys praneštas',
  agendaLinkCopied: 'Nuoroda nukopijuota!',
  agendaStartsAt: 'Prasideda ',
  agendaEndsAt: 'Baigiasi ',
  agendaSpeakers: 'Diskusijos Dalyviai',
  agendaSeeAllSpeakers: 'Rodyti visus',
  agendaAddToSchedule: 'Pridėti į mano tvarkaraštį',
  agendaRemoveFromSchedule: 'Pašalinti iš mano tvarkaraščio',
  agendaAddedToSchedule: 'Pridėta į mano tvarkaraštį!',
  agendaRemovedFromSchedule: 'Pašalinta iš mano tvarkaraščio!',
  agendaCalendar: 'Kalendorius',
  agendaAddToCalendar: 'Pridėti į sistemos kalendorių?',
  agendaCalendarSkip: 'Praleisti',
  agendaCalendarAdd: 'Pridėti',
  agendaNow: 'DABAR',
  agendaModerators: 'Moderatoriai',

  QnATitle: 'Klausimai ir atsakymai',
  askASpeaker: 'Paklauskite pranešėjo',
  askAQuestion: 'Užduokite klausimą',
  askQuestionPlaceholder: 'Įveskite savo klausimą čia',
  cancel: 'Atšaukti',
  ask: 'Klausti',
  deleteConfirmation: 'Ar norite ištrinti šį klausimą?',
  questionDeleted: 'Klausimas sėkmingai ištrintas!',
  rateSession: 'Įvertink diskusiją'
}
